import Button from "./Button";
import Input from "./Input";
import Select from "./Select";

const DataActions = ({
  classNames = {
    rootContainer: "",
    inputContainer: "",
    input: "",
    button: "",
  },
  showSearch = true,
  searchInputProps = { placeholder: "Search" },
  showActionOptions = false,
  dropdownProps = {},
  actionButtonProps = {
    className: "",
  },
}) => {
  return (
    <div
      className={`d-flex flex-column flex-sm-row align-items-center justify-content-between gap-3 ${classNames.rootContainer}`}
    >
      <div className="flex-grow-1 w-100">
        {showSearch && (
          <div
            style={{ maxWidth: "300px" }}
            className={classNames.inputContainer}
          >
            <Input
              {...searchInputProps}
              className={`${searchInputProps.className} ${classNames.input}`}
              type="text"
              autoComplete="off"
            />
          </div>
        )}
      </div>
      {showActionOptions && (
        <div className="flex-grow-1 d-flex align-items-center justify-content-end gap-2 w-100">
          <div style={{ maxWidth: "150px" }}>
            <Select {...dropdownProps} placeholder="Select Action" label={""} />
          </div>
          <Button
            {...actionButtonProps}
            className={`submit rounded ${actionButtonProps.className} ${classNames.button}`}
          >
            Submit
          </Button>
        </div>
      )}
    </div>
  );
};

export default DataActions;
